import React from 'react'
import { Input } from '..'
import cn from 'classnames'
type Props = {
  onChange: Function
  placeholder?: string
  label?: string
  className?: string
}

const SearchFiltering: React.FC<Props> = ({ onChange, placeholder, label, className = '' }) => {
  return (
    <Input
      containerClass={cn('col-lg-5 px-0 mb-2', className)}
      placeholder={placeholder || 'Input your keywords...'}
      appendIcon='search'
      label={label === undefined ? 'Search' : label}
      aria-label='Search'
      onChange={(e: React.FormEvent<HTMLInputElement>) => onChange(e.currentTarget.value)}
    />
  )
}

export default SearchFiltering
